var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewWidthInside3Fa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "169px",
    height: "169px",
    viewBox: "0 0 450 451.5",
    enableBackground: "new 0 0 450 451.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    y: 54,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 77,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 250.5,
    x2: 329.1,
    y2: 250.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,259.4 108,250.5 123.5,241.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,259.4 342,250.5 326.5,241.5  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 103.9,
    x2: 329.1,
    y2: 103.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,112.8 108,103.9 123.5,94.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,112.8 342,103.9 326.5,94.9  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 390.9,
    x2: 329.1,
    y2: 390.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,399.8 108,390.9 123.5,381.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,399.8 342,390.9 326.5,381.9  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M406.8,106.1c0-1.4,0-2.7-0.1-4c0-1.3-0.2-2.6-0.3-3.9c-0.2-1.2-0.4-2.4-0.7-3.5c-0.3-1.1-0.7-2-1.2-2.8 l1.7-1.1c0.6,0.9,1,2,1.4,3.2c0.4,1.2,0.7,2.6,0.9,4.1c0.1,0.7,0.2,1.3,0.2,2c0.1,0.7,0.1,1.4,0.1,2.1c0,0.7,0.1,1.4,0.1,2 c0,0.7,0,1.3,0,1.9H406.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M411.4,237.2c0,0,0,0.1,0,0.2c0,0.1,0,0.3,0.1,0.5c0,0.2,0,0.4,0.1,0.7c0,0.3,0,0.5,0,0.8 c0,1.6-0.4,2.8-1.1,3.7v0c-0.3,0.4-0.8,0.7-1.3,1c-0.5,0.2-1,0.3-1.6,0.3c-0.3,0-0.6,0-0.9-0.1s-0.5-0.1-0.8-0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,0.7,0.2,1.3,0.2,2c0.1,0.7,0.1,1.4,0.1,2.1s0.1,1.4,0.1,2c0,0.7,0,1.3,0,1.9h-2.1 c0-1.1,0-2.2,0-3.3s-0.1-2.2-0.2-3.2c-0.1-1-0.2-2-0.4-3c-0.2-0.9-0.4-1.8-0.7-2.6c-0.1-0.4-0.3-0.7-0.5-1.1 c-0.2-0.3-0.4-0.7-0.6-1.1l1.7-1.1c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.2,0.2,0.4,0.3,0.6s0.2,0.4,0.3,0.6s0.2,0.5,0.3,0.7 c0.2,0.4,0.3,0.7,0.5,1c0.2,0.3,0.3,0.6,0.5,0.8s0.4,0.4,0.7,0.5c0.3,0.1,0.6,0.2,1,0.2c0.3,0,0.5,0,0.8-0.1 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.3,0.3-0.5s0.2-0.4,0.2-0.7c0.1-0.2,0.1-0.5,0.1-0.7s0-0.5,0-0.7c0-0.3,0-0.6,0-0.9 c0-0.3-0.1-0.5-0.1-0.7L411.4,237.2z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M413,377.5c0.1,0.6,0.2,1.2,0.3,1.7c0.1,0.5,0.1,1,0.1,1.4c0,1.3-0.3,2.3-0.8,3c-0.3,0.3-0.6,0.6-0.9,0.7 s-0.8,0.2-1.2,0.2c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.4-0.6-0.6l-0.2,0.3 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.3,0-0.5,0-0.7,0s-0.4-0.1-0.6-0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2 c0.1,0.7,0.2,1.3,0.2,2s0.1,1.4,0.1,2.1s0,1.4,0.1,2c0,0.7,0,1.3,0,1.9h-2.1c0-0.3,0-0.6,0-0.9s0-0.6,0-0.9c0-1,0-2-0.1-3 c-0.1-1-0.2-1.9-0.3-2.8c-0.1-0.9-0.3-1.8-0.5-2.6c-0.2-0.8-0.5-1.6-0.7-2.3c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1 c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1-0.3-0.3-0.5-0.4-0.8l1.9-1.1c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.4 c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.3,0.3,0.7,0.5,1.1c0.2,0.4,0.4,0.8,0.5,1.1s0.3,0.5,0.4,0.7 c0.2,0.2,0.3,0.3,0.5,0.4s0.5,0.1,0.8,0.1c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.2,0.3-0.5,0.5-1s0.2-0.9,0.2-1.5 c0-0.1,0-0.2,0-0.4s0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.3,0-0.3l2.1-0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4 c0,0.2,0,0.4,0,0.6c0,0.4,0.1,0.9,0.2,1.3c0.1,0.5,0.2,0.9,0.3,1.3c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.2,0.2,0.3,0.3 c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.3,0,0.4-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.2s0.1-0.2,0.1-0.3 c0-0.1,0.1-0.3,0.1-0.5c0-0.2,0-0.4,0-0.7c0-0.3,0-0.7-0.1-1.1c0-0.4-0.1-1-0.2-1.6L413,377.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWidthInside3Fa);
export default __webpack_public_path__ + "static/media/new_width_inside_3_fa.de0c8b7cde86cf5d8be6a516b0db13e1.svg";
export { ForwardRef as ReactComponent };